import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardNavigation from '../DashboardNavigation/DashboardNavigation';
import { useAuth } from '../../../shared/contexts/AuthContext';
import './DashboardLayout.css';

const DashboardLayout = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !isAuthenticated) {
      navigate('/businesssignin');
    }
  }, [isAuthenticated, loading, navigate]);

  if (loading) {
    return (
      <div className="dashboard-layout loading">
        <div className="loading-spinner">
          <div className="spinner"></div>
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return null; // Will redirect in useEffect
  }

  return (
    <div className="dashboard-layout">
      <DashboardNavigation />
      <main className="dashboard-main">
        {children}
      </main>
    </div>
  );
};

export default DashboardLayout;
